import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Sparkles, Wallet } from "lucide-react";

import { ActionButton, Modal } from "../../customer/account/account.ui";
import { formatMoney } from "../../customer/account/filing/filing.helpers";

import loginService from "../../../domain/services/login.service";
import { obtainCustomerRepurchaseVoucher } from "../../../domain/services/marketing/voucher.service";
import { isUsableRepurchaseVoucher } from "../../../domain/services/marketing/repurchase.voucher";
import { voucherTrackerUserId } from "../../../domain/constant/customer.repurchase.voucher.constant";

// Sem saldo para a taxa: mesmo incentivo de renovação da pendência financeira (cupom de recompra quando houver).
export default function FilingBalanceModal({ open, onClose, fee, remaining, verbs }) {
    const history = useHistory();
    const [voucher, setVoucher] = useState(null);

    useEffect(() => {
        if (!open)
            return;

        const customerId = loginService.getUserAuthentication()?.customer?.id;
        obtainCustomerRepurchaseVoucher(customerId, { ignoreMinimumCreditAmount: true })
            .then(({ data }) => setVoucher(isUsableRepurchaseVoucher(data) ? data : null))
            .catch(() => setVoucher(null));
    }, [open]);

    const renew = () => history.push(voucher
        ? `/marketplace?voucher=${voucher.code}&sellerUserId=${voucherTrackerUserId}`
        : '/marketplace');

    return (
        <Modal
            open={open}
            onClose={onClose}
            icon={Wallet}
            size="sm"
            title="Saldo insuficiente"
            description={`${verbs.theNoun[0].toUpperCase()}${verbs.theNoun.slice(1)} custa ${formatMoney(fee)} e o seu pacote tem ${formatMoney(remaining)} disponível. Renove e volte aqui: a peça continua pronta.`}
            footer={(
                <>
                    <ActionButton variant="secondary" onClick={onClose}>Agora não</ActionButton>
                    <ActionButton onClick={renew}>Renovar pacote</ActionButton>
                </>
            )}
        >
            {voucher && (
                <div className="flex items-center gap-2 rounded-lg bg-primaryTint px-4 py-3 text-sm text-primaryDark">
                    <Sparkles className="h-4 w-4 shrink-0" aria-hidden="true" />
                    <span>Renovando agora você economiza <b>{formatMoney(voucher.discount)}</b>.</span>
                </div>
            )}
        </Modal>
    );
}
